'use client';

import React, { type ReactElement } from 'react';
import { type CollectionItem } from '@/common/types/collection.type';
import { useDomainStore } from '@/store/use-domain.store';
import { selectSetVendorId, useVendorStore } from '@/store/use-vendor.store';
import { useRouter } from 'nextjs-toploader/app';
import { isMobile } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import AnalyticsWrapper from '@/common/components/analytics-wrapper';
import CollectionCard from '@/common/components/collection-card/collection-card.component';
import Text from '@/common/components/text/text.component';
import 'swiper/css';

interface Props {
  vendorId: number;
  vendorSlug: string;
  collections: CollectionItem[];
}

export default function Collection({
  vendorId,
  collections,
  vendorSlug,
}: Props): ReactElement {
  const router = useRouter();
  const isTenant = useDomainStore((state) => state.isTenant);
  const setVendorId = useVendorStore(selectSetVendorId);

  const handleClick = (slug: string, id: number) => {
    const formattedslug = slug.replace(/\s+/g, '-');

    setVendorId(vendorId);
    router.push(
      `${!isTenant ? vendorSlug : ''}/collection/${id}/${formattedslug}`
    );
  };

  return (
    <div className="mt-3 flex w-full flex-col gap-5">
      {collections.length > 0 && (
        <>
          <Text className="mb-3 mt-4 font-semibold text-l lg:text-xl text-black-400">
            کالکشن‌ها
          </Text>

          <div>
            <Swiper
              slidesPerView={1.2}
              spaceBetween={20}
              grabCursor
              cssMode={isMobile}
              wrapperClass="relative"
              breakpoints={{
                1024: {
                  slidesPerView: 4.2,
                },
              }}
            >
              {collections.map((collection) => (
                <SwiperSlide key={collection.assortmentId}>
                  <AnalyticsWrapper
                    analytics={['store-click-collection-secondaries-v1']}
                  >
                    <CollectionCard
                      id={collection.assortmentId}
                      collectionItem={{
                        title: collection.title,
                        description: collection.description,
                        imageCover: collection.assortmentImageUrl,
                      }}
                      onClick={() => {
                        handleClick(collection.title, collection.assortmentId);
                      }}
                    />
                  </AnalyticsWrapper>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </>
      )}
    </div>
  );
}
